import { defineMessages } from '@transcend-io/internationalization';

export const noValidScopeMessages = defineMessages(
  'privacy-center.containers.NoValidScope.noValidScope',
  {
    title: {
      defaultMessage: 'Requires Verification',
      description: 'The title of the modal when a user lacks a valid scope.',
    },
    description: {
      defaultMessage:
        'For security reasons, this operation requires additional verification.',
      description:
        'The message displayed in the modal when a user lacks a valid scope.',
    },
    confirm: {
      defaultMessage: 'Log in',
      description:
        'The button label used to confirm the login action in the modal when the user lacks a valid scope.',
    },
  },
);
